import {defineMessages} from 'react-intl';

export default defineMessages({
	clearAll: {
		id: 'plp.refinements.clearAll',
		defaultMessage: 'Clear All',
	},
	viewResults: {
		id: 'plp.refinements.viewResults',
		defaultMessage: 'View {totalResults} results',
	},
});